import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="bg-navy text-text-light py-24 px-4 relative overflow-hidden" data-id="element-126">
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-copper/50 to-transparent" data-id="element-127" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-copper/50 to-transparent" data-id="element-128" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-129">
        <FadeIn data-id="element-130">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-cream mb-6 leading-tight" data-id="element-131">
            Introducing the <br data-id="element-132" />
            <span className="text-copper italic" data-id="element-133">
              Anti-Foreclosure Protocol
            </span>
          </h2>
          <p className="text-xl md:text-2xl font-body font-light text-cream/90 mb-12 max-w-3xl mx-auto" data-id="element-134">
            This isn't a book about real estate investing; it is a tactical
            manual for administrative survival.
          </p>
        </FadeIn>

        <div className="bg-navy-light/50 border border-copper/20 p-8 md:p-12 text-left relative" data-id="element-135">
          <div className="absolute -top-3 -left-3 w-6 h-6 border-t border-l border-copper" data-id="element-136" />
          <div className="absolute -bottom-3 -right-3 w-6 h-6 border-b border-r border-copper" data-id="element-137" />

          <FadeIn delay={0.2} data-id="element-138">
            <p className="text-lg md:text-xl font-body leading-relaxed text-cream/80 mb-6" data-id="element-139">
              We use{' '}
              <strong className="text-copper font-semibold tracking-wide uppercase text-sm mx-1" data-id="element-140">
                Statutory Transparency
              </strong>
              —a specific method of notifying banks and creditors under federal
              law (CFPB rules) that legally forces them to stop collection
              activity and recognize your rights as the heir.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-141">
            <p className="text-lg md:text-xl font-body leading-relaxed text-cream/80" data-id="element-142">
              We create a{' '}
              <strong className="text-copper font-semibold tracking-wide uppercase text-sm mx-1" data-id="element-143">
                Neutral Ground
              </strong>{' '}
              where the holding costs stop bleeding, giving you the clarity to
              make a logical decision instead of a panicked one.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}